import React from 'react'
import Summary from 'pages/Summary'

const SummaryPage = () => <Summary />

export default SummaryPage
